import { createRoute, useParams, Link } from '@tanstack/react-router';
import { Shell } from '../components/layout/Shell';
import { OfferDetail } from '../components/community/OfferDetail';
import { useOffer } from '../hooks/useCommunity';
import { useTranslation } from '../i18n';
import { Route as rootRoute } from './__root';
import styles from './offers.$offerId.module.css';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/offers/$offerId',
  component: OfferDetailPage,
});

function OfferDetailPage() {
  const { offerId } = useParams({ from: '/offers/$offerId' });
  const { t } = useTranslation();
  const { data: offer, isLoading } = useOffer(offerId);

  return (
    <Shell>
      <div className={styles.page}>
        <Link to="/offers" className={styles.backLink}>
          &larr; {t('community.backToOffers')}
        </Link>

        {isLoading ? (
          <div>{t('community.loadingOffer')}</div>
        ) : !offer ? (
          <div className={styles.notFound}>{t('community.offerNotFound')}</div>
        ) : (
          <OfferDetail offer={offer} />
        )}
      </div>
    </Shell>
  );
}
